// Module
var code = `<div class="modal-dialog modal-lg" role="document" id="mapReduceIndexSyntaxDialog">
    <div class="modal-content">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-cancel"></i></button>
            <h3 class="margin-bottom margin-top">The Index Reduce Function</h3>
            <div class="margin-bottom">
                The Reduce function will group the results from the Maps stage based on the specified field and sum up their values.<br>
                The outcome of both the Map and the Reduce functions must have the <strong>same</strong> structure.
            </div>
            <hr>
            <div class="margin-bottom">
                The following Map-Reduce index definition examples index total revenue, per supplier, per category, for products with price per unit > 10 that are not discontinued.
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <h3 class="margin-top">
                        <strong>LINQ </strong>Map-Reduce Example:
                    </h3>
                    <div data-bind="foreach: \$data.constructor.linqSamples">
                        <pre class="copy-area"><a href="#" class="copy-button-hidden" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, title)"><i class="icon-copy"></i></a><span data-bind="html: html"></span></pre>
                    </div>
                </div>
                <div class="col-lg-6">
                    <h3 class="margin-top">
                        <strong>JavaScript </strong>Map-Reduce Example:
                    </h3>
                    <div data-bind="foreach: \$data.constructor.javascriptSamples">
                        <pre class="copy-area"><a href="#" class="copy-button-hidden" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, title)"><i class="icon-copy"></i></a><span data-bind="html: html"></span></pre>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;